// A "Miért kaptad a terápiát?" kérdés opciólistája — Onboarding.tsx és
// Profil.tsx közös forrása, hogy a fogalom (id + label) egy helyről jöjjön.

export type TherapyReasonId = "cukorbetegseg" | "testsulycsokkenes" | "mindketto";

export interface TherapyReasonOption {
  id: TherapyReasonId;
  label: string;
}

export const THERAPY_REASON_OPTIONS: TherapyReasonOption[] = [
  { id: "cukorbetegseg", label: "Cukorbetegség" },
  { id: "testsulycsokkenes", label: "Testsúlycsökkentés" },
  { id: "mindketto", label: "Mindkettő" },
];
